import { TrackingActions, TrackingActionTypes } from '../actions/tracking';
import { Event } from '../models/event';

export interface State {
  eventQueue: Event[];
}

export const initialState: State = {
  eventQueue: []
};

export function reducer(state = initialState, action: TrackingActions): State {
  switch (action.type) {
    case TrackingActionTypes.Enqueue:
      return {
        ...state,
        eventQueue: action.payload
      };

    default:
      return state;
  }
}
